import { ReactNode } from "react";

export type ExternalAuthErrorsProviderProps = {
    children: ReactNode;
  };
export const EXTERNAL_AUTH_DATA = "externalAuthData";

export type StatusExternaAgentlLead = "ERROR" | "WARNING" | "EMPTY_LEAD" | "NO_SET" | "NEW_LEAD" | null;